import i18n  from "i18next";
import french from "./french.json";
import english from "./english.json";
import {initReactI18next} from "react-i18next";
import {store} from "../redux/store";

function initI18n(lang) {
    const languageDetector = {
        type: 'languageDetector',
        async: true,
        detect: async (callback) => {
            const storedLanguageTag = store.getState().lang.value;
            if (storedLanguageTag) {
                return callback(storedLanguageTag);
            }
        },
        init: () => {},
        cacheUserLanguage: () => {},
    };

    i18n.use(languageDetector).use(initReactI18next).init({
        debug:false,
        resources:{
            en:english,
            fr:french
        },
        react:{
            useSuspense:false
        }
    });
}

export default initI18n ;
